import { render, staticRenderFns } from "./newsList.vue?vue&type=template&id=003c47e8"
import script from "./newsList.vue?vue&type=script&lang=ts"
export * from "./newsList.vue?vue&type=script&lang=ts"
import style0 from "./newsList.vue?vue&type=style&index=0&id=003c47e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports